import React from 'react';
import { Box, Typography } from '@mui/material';
import { Star, StarBorder } from '@mui/icons-material';
import { DESIGN_TOKENS } from '../../../styles/constants';

interface StarRatingProps {
  rating: number;
  showNumber?: boolean;
  size?: 'small' | 'large';
}

const StarRating: React.FC<StarRatingProps> = ({ rating, showNumber = true, size = 'small' }) => {
  const fullStars = Math.floor(rating);
  const emptyStars = 5 - Math.ceil(rating);
  const starSize = size === 'small' ? 16 : 48;

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        {[...Array(fullStars)].map((_, index) => (
          <Star
            key={`full-${index}`}
            sx={{
              fontSize: starSize,
              color: '#AC654D',
            }}
          />
        ))}
        {[...Array(emptyStars)].map((_, index) => (
          <StarBorder
            key={`empty-${index}`}
            sx={{
              fontSize: starSize,
              color: '#C5CBD3',
            }}
          />
        ))}
      </Box>
      {showNumber && (
        <Typography
          sx={{
            fontFamily: DESIGN_TOKENS.typography.fontFamily,
            fontSize: '16px',
            fontWeight: 400,
            lineHeight: '22.4px',
            color: '#000000',
          }}
        >
          {rating}
        </Typography>
      )}
    </Box>
  );
};

export default StarRating;


